/**
 * i18n (Internationalization) System
 */
import { en, TranslationKeys } from './translations/en';
import { ko } from './translations/ko';

export type Language = 'en' | 'ko';

export const translations: Record<Language, TranslationKeys> = {
  en,
  ko,
};

export const languageNames: Record<Language, string> = {
  en: 'English',
  ko: '한국어',
};

export const defaultLanguage: Language = 'en';

// Local storage key for persisting language preference
export const LANGUAGE_STORAGE_KEY = 'notesense-language';

// Get saved language from local storage
export function getSavedLanguage(): Language {
  if (typeof window === 'undefined') return defaultLanguage;

  const saved = localStorage.getItem(LANGUAGE_STORAGE_KEY);
  if (saved && (saved === 'en' || saved === 'ko')) {
    return saved;
  }

  // Try to detect browser language
  const browserLang = navigator.language.split('-')[0];
  if (browserLang === 'ko') {
    return 'ko';
  }

  return defaultLanguage;
}

// Save language preference to local storage
export function saveLanguage(lang: Language): void {
  if (typeof window !== 'undefined') {
    localStorage.setItem(LANGUAGE_STORAGE_KEY, lang);
  }
}

export type { TranslationKeys };
